import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];
  static values = { initialValue: String, predicted: Boolean };

  connect () {
    this.setSubmitLabel(false);
  }

  resetForm () {
    const form = this.element.querySelector("form");
    const input = this.element.querySelector("sl-input[name='preliminary_ebitda[value]']");

    form?.reset();
    this.clearFieldErrors(form);
    if (input) input.value = this.initialValueValue;

    this.setSubmitLabel(false);
  }

  clearFieldErrors (form) {
    form?.querySelectorAll(".field_with_errors").forEach(element => {
      element.classList.remove("field_with_errors");
    });
    form?.querySelectorAll(".error.ts-input__help").forEach(element => element.remove());
  }

  updateSubmitLabel ({ target }) {
    this.setSubmitLabel(target.value.trim() !== this.initialValueValue);
  }

  updateSubmitLabelFromForm () {
    const form = this.element.querySelector("form");

    if (!form) return;

    this.setSubmitLabel(form.dataset.preliminaryEbitdaValueChanged === "true");
  }

  setSubmitLabel (changed) {
    if (!this.hasSubmitButtonTarget) return;

    const label = this.predictedValue && !changed ? "Confirm" : "Save";
    this.submitButtonTarget.querySelector("sl-button").textContent = label;
  }
}
